import dateToString from '../../../function/dateToString';
import { defaultPerPageValue } from '../../../constants/PaginationPerPageConstants';
import { sortValuesPrispevkyVestnika } from '../../../constants/SortConstants';
import PrispevokVestnikaListFilter from '../../../model/PrispevokVestnikaListFilter';

export default (
  page: number,
  perPage: number,
  sort: Array<string>,
  filter: PrispevokVestnikaListFilter,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams();

  if (filter.searchTextCislo) {
    updatedSearchParams.set('cislo', filter.searchTextCislo);
  }

  if (filter.searchTextNazov) {
    updatedSearchParams.set('nazov', filter.searchTextNazov);
  }

  if (filter.searchTextVyraz) {
    updatedSearchParams.set('hladanyVyraz', filter.searchTextVyraz);
  }

  if (filter.searchTextRocnik) {
    updatedSearchParams.set('datumZverejneniaRok', filter.searchTextRocnik);
  }

  if (filter?.rezort?.uuid) {
    updatedSearchParams.set('vestnikUuid', filter.rezort.uuid);
  }

  if (filter.datumUcinnostiOd) {
    updatedSearchParams.set('datumUcinnostiOd', dateToString(filter.datumUcinnostiOd));
  }

  if (filter.datumUcinnostiDo) {
    updatedSearchParams.set('datumUcinnostiDo', dateToString(filter.datumUcinnostiDo));
  }

  if (filter.datumZverejneniaOd) {
    updatedSearchParams.set('datumZverejneniaOd', dateToString(filter.datumZverejneniaOd));
  }

  if (filter.datumZverejneniaDo) {
    updatedSearchParams.set('datumZverejneniaDo', dateToString(filter.datumZverejneniaDo));
  }

  if (page && page !== 1) {
    updatedSearchParams.set('page', page.toString());
  }

  if (perPage && perPage !== defaultPerPageValue) {
    updatedSearchParams.set('perPage', perPage.toString());
  }

  if (sort[0] && sort[1]) {
    if (!sortValuesPrispevkyVestnika.includes(sort[0])
      || (sort[1] !== 'asc' && sort[1] !== 'desc')) {
      updatedSearchParams.delete('sort');
    } else {
      updatedSearchParams.set('sort', `${sort[0]},${sort[1]}`);
    }
  }
  return updatedSearchParams;
};
